module.exports = __webpack_public_path__ + "img/c4.b73418c.png";